'use strict';

export class ChangePasswordDialogModel {
    constructor(options) {
        this.authService = options.authService;
        this.portal = options.portal;
        this.username = options.username;
        this.authToken = options.authToken;
        this.password = options.password;

        this.pwdRequirements = [];
        this.numberRegex = /\d/;
        this.specialCharsRegex = /[!@#$%^&*(),.?":{}|<>]/;
        this.newPassword = '';
        this.repeatedNewPassword = '';
    }

    async init() {
        let getPasswordRequirementsResp = await this.authService.getPasswordRequirements(this.portal);
        this.pwdRequirements = getPasswordRequirementsResp.data;
    }

    async changePassword() {
        let result = this.validatePassword();
        if (!result.isError) {
            await this.authService.changeTechnologistPassword(this.username, this.newPassword, this.portal, this.authToken);
        }
        return result;
    }

    validateAndRequirements(andRequirements) {
        _.some(andRequirements, req => {
            switch (req) {
                case 'RequireCapitalLetter':
                    if (_.every(this.newPassword, character => { return character === character.toLowerCase(); })) {
                        this.error = `You must have at least one uppercase letter`;
                    }
                    break;
                case 'RequireLowercaseLetter':
                    if (_.every(this.newPassword, character => { return character === character.toUpperCase(); })) {
                        this.error = `You must have at least one lowercase letter`;
                    }
                    break;
                case 'RequireNumericChar':
                    if (!this.numberRegex.test(this.newPassword)) {
                        this.error = `You must have at least one number`;
                    }
                    break;
                case 'RequireSpecialChar':
                    if (!this.specialCharsRegex.test(this.newPassword)) {
                        this.error = `You must have at least one special character`;
                    }
                    break;

                default:
                    break;
            }
            return !!this.error;
        });
    }

    validateOrRequirements(orRequirements) {
        let error = '';
        let errors = [];
        let optionalRequirementsSatisfied = false;
        _.each(orRequirements, req => {
            if (req === 'RequireCapitalLetter' && !optionalRequirementsSatisfied) {
                if (_.every(this.newPassword, character => { return character === character.toLowerCase(); })) {
                    errors.push(`uppercase letter`);
                } else {
                    optionalRequirementsSatisfied = true;
                }
            }
            if (req === 'RequireLowercaseLetter' && !optionalRequirementsSatisfied) {
                if (_.every(this.newPassword, character => { return character === character.toUpperCase(); })) {
                    errors.push(`lowercase letter`);
                } else {
                    optionalRequirementsSatisfied = true;
                }
            }
            if (req === 'RequireNumericChar' && !optionalRequirementsSatisfied) {
                if (!this.numberRegex.test(this.newPassword)) {
                    errors.push(`number`);
                } else {
                    optionalRequirementsSatisfied = true;
                }
            }
            if (req === 'RequireSpecialChar' && !optionalRequirementsSatisfied) {
                if (!this.specialCharsRegex.test(this.newPassword)) {
                    errors.push(`special character`);
                } else {
                    optionalRequirementsSatisfied = true;
                }
            }
        });
        if (!optionalRequirementsSatisfied && errors.length > 0) {
            error = `You must have at least one ` + errors.join(' or ');
        }
        this.error = error;
    }

    validatePassword() {
        const { passwordRequirementsModel } = this.pwdRequirements;
        let andRequirements = [];
        let orRequirements = [];
        for (var requirement in passwordRequirementsModel) {
            var req = passwordRequirementsModel[requirement];
            if (req.IsRequired) {
                if (req.Statement === "Or") {
                    orRequirements.push(requirement);
                } else {
                    andRequirements.push(requirement);
                }
            }
        }
        this.error = '';
        if (this.newPassword !== this.repeatedNewPassword) {
            this.error = 'The passwords you typed do not match. Please enter the new password in both boxes.';
        } else if (this.pwdRequirements && this.pwdRequirements.pwdReq && !this.newPassword) {
            this.error = `Current security policy does not permit a blank password. Please enter your new password.`;
        } else if (this.pwdRequirements && this.newPassword.length < this.pwdRequirements.pwdMinLen) {
            this.error = `Current security policy requires a password of at least ${this.pwdRequirements.pwdMinLen} ${this.pwdRequirements.pwdMinLen.length > 1 ? 'characters' : 'character'}`;
        } else if (this.newPassword === this.password) {
            this.error = `The password has not been changed. Please enter the new password.`;
        } else if (andRequirements.length > 0) {
            this.validateAndRequirements(andRequirements);
        }
        if (!this.error && orRequirements.length > 0) {
            this.validateOrRequirements(orRequirements);
        };
        if (!this.error) {
            return {
                isError: !!this.error,
                newPassword: this.newPassword
            };
        } else {
            return {
                isError: !!this.error
            };
        }
    }
}



// WEBPACK FOOTER //
// ./src/scripts/models/changePasswordDialogModel.js